// src/utils/chunk-error-handler.ts

import { TAny } from "./interfaces/globals";

/**
 * Sets up global handlers for chunk loading errors and unhandled promise rejections.
 * @returns {void}
 */
export function setupChunkErrorHandling(): void {
  window.addEventListener("vite:preloadError", (event: TAny) => {
    event.preventDefault();
    window.location.reload();
  });

  window.addEventListener("unhandledrejection", (event) => {
    const err = event.reason;
    if (
      err?.name === "ChunkLoadError" ||
      /Loading chunk \d+ failed/.test(err?.message) ||
      /Failed to fetch dynamically imported module/.test(err?.message)
    ) {
      event.preventDefault();
      window.location.reload();
    }
  });
}
